<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.57861 16C1.14986 16 0.782698 15.8472 0.477119 15.5416C0.172061 15.2366 0.0195312 14.8697 0.0195312 14.4409V3.52741C0.0195312 3.09866 0.172061 2.7315 0.477119 2.42592C0.782698 2.12086 1.14986 1.96833 1.57861 1.96833H8.53597L6.9769 3.52741H1.57861V14.4409H12.4921V9.02314L14.0512 7.46407V14.4409C14.0512 14.8697 13.8987 15.2366 13.5936 15.5416C13.288 15.8472 12.9209 16 12.4921 16H1.57861ZM10.2899 2.41657L11.4008 3.50792L6.25583 8.65286V9.7637H7.34718L12.5116 4.59927L13.6225 5.69062L8.00979 11.3228H4.69675V8.00974L10.2899 2.41657ZM13.6225 5.69062L10.2899 2.41657L12.2388 0.467722C12.5506 0.155908 12.9242 0 13.3597 0C13.7947 0 14.1616 0.155908 14.4605 0.467722L15.5518 1.57856C15.8506 1.87739 16 2.24117 16 2.66991C16 3.09866 15.8506 3.46244 15.5518 3.76127L13.6225 5.69062Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>